import Close from '../../src/legacy/Close.tsx';
export default Close;
